import React from 'react';
export default class CommonHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        const _this = this;
        return (
            <header className="mui-bar mui-bar-nav">
                <a className="mui-action-back mui-icon mui-icon-left-nav mui-pull-left" onClick= {_this.handlerBack.bind(_this) }></a>
                <h1 className="mui-title"></h1>
            </header>  
        );
    }
    handlerBack(){
         const _this = this;
        _this.props.history.goBack();
    }
}


